module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "preface"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PREFACE")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Scientists are trained to be meticulous when they speak about their work. That’s why I like getting my neuroscience colleagues tipsy. For years, after plying them with spirits or cannabis, I’ve been asking brain researchers the same simple question: “What idea about brain function would you most like to explain to the world?” I’ve been delighted with their responses. They don’t delve into the minutiae of their latest experiments or lapse into nerd speak. They sit up a little straighter, open their eyes a little wider, and give clear, insightful, and often unpredictable or counterintuitive answers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book is the result of those conversations. I’ve invited a group of the world’s leading neuroscientists, my dream team of unusually thoughtful, erudite, and clear-thinking researchers, to answer that key question in the form of a short essay. Although I have taken care to invite contributors with varied expertise, it has not been my intention to create an informal comprehensive textbook of neuroscience in miniature. Rather, I have chosen a diverse set of scientists but have encouraged each author to choose her or his own topic to tell the scientific story that she or he is burning to share.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But let’s face it: most books about the brain are not written by brain researchers, and most of them are not very good. Many are dull, and those that are readable are often uninformed or even fraudulent. This is the age of the brain, but thoughtful people have become understandably skeptical, having been inundated by a fire hose of neurobullshit (“looking at the color blue makes you more creative” or “the brains of Republicans and Democrats are structurally different”). I believe that readers hunger for reliable and compelling information about the biological basis of human experience. They want to learn what is known, what we suspect but cannot yet prove, and what remains a complete mystery about neural function. And they want to believe what they read.")])]), _c('p', {
    staticClass: "indentb"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("The purpose of this book is not to launch a screed against neurobullshit but rather to offer an honest, positive recounting of what we know about the biology that underlies your everyday experience, along with some speculation about what the future will hold in terms of understanding the nervous system, treating its diseases, and interfacing with electronic devices. Along the way, we’ll explore the genetic basis of personality; the brain substrates of aesthetic responses; and the origin of strong subconscious drives for love, sex, food, and psychoactive drugs. We’ll examine the origins of human individuality, empathy, and memory. In short, we’ll do our best to explain the biological basis of our human mental and social life and the means by which it interacts with and is molded by individual experience, culture, and the long reach of evolution. And we’ll be honest about what is known and what is not. Welcome to the think tank!")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "signature"
  }, [_vm._v("David J. Linden")]), _vm._v(" "), _c('p', {
    staticClass: "signature"
  }, [_vm._v("Baltimore, USA")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-769c4412","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface.vue
// module id = 69
// module chunks = 0